import React from 'react';
import { Link } from 'react-router-dom';
import './ByingConfidence.css'
const ByingConfidence = () => {
    return (
        <div className='bying-top'>
            <section className='baying-main'>
                <div>
                    <h1 className='fs-1 text-black'>
                        WHY BUYING WITH OODLE GIVES YOU MORE CONFIDENCE
                    </h1>
                </div>
                <div className='col-6 pre-approved'>
                    <h1 className='fs-1 text-black p-0 '>
                        GET PRE-APPROVED CAR FINANCE IN MINUTES WITH OODLEPAY
                    </h1>
                </div>

                <div className='col-9 m-auto pt-3'>
                    <p>
                        Applying for a pre-approval won’t impact on your credit score. <br />
                        <span className='fw-bold'>Representative APR 15%.</span> Finance subject to status. 18+. Terms and Conditions apply.
                    </p>
                </div>
                <div className='py-5'>
                    <Link className='banner-button'>Set your budget</Link>
                </div>

                <div className='d-md-flex justify-content-center'>
                    <h5>Excellent</h5>
                    <div className='mx-3 mb-3'>
                        <i className="review-icon fas fa-star"></i>
                        <i className="review-icon mx-2 fas fa-star"></i>
                        <i className="review-icon fas fa-star"></i>
                        <i className="review-icon fas mx-2 fa-star"></i>
                        <i className="review-icon fas fa-star"></i>
                    </div>
                    <p><span className='fw-bold'>6,567</span> Reviews on</p>
                    <div className='d-flex mx-3 justify-content-center'>
                        <i className="trust-single fas fa-star mt-1 me-1"></i>
                        <p>Trustpilot</p>
                    </div>
                </div>

                <div >
                    <h1 className='fs-1 text-black py-5'>EVEN MORE REASONS TO CHOOSE OODLE</h1>
                    <div className='even-card'>

                    </div>
                </div>

            </section>

        </div>
    );
};

export default ByingConfidence;